import {
  apiRequest,
  masterWorkUnit,
  wfhExport
} from "../../../../../services/adapters/Laporan/wfhService";

class IndexRepository {
  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchExport_WFH = async (query) => {
    return await apiRequest(
      "get",
      wfhExport,
      {
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
